import { render, staticRenderFns } from "./CalendarPurchasing.vue?vue&type=template&id=61a1def7&scoped=true"
import script from "./CalendarPurchasing.vue?vue&type=script&lang=js"
export * from "./CalendarPurchasing.vue?vue&type=script&lang=js"
import style0 from "./CalendarPurchasing.vue?vue&type=style&index=0&id=61a1def7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a1def7",
  null
  
)

export default component.exports